import React from 'react';
import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { SearchFormValues, searchSchema } from '../../schemas';
import { useSearchFieldStates } from '../../hooks';
import { BasicInfoTab } from './BasicInfoTab';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (filters: BanHangPayload) => void;
}

function SearchDialog({ open, onClose, onSearch }: SearchDialogProps) {
  const searchFieldStates = useSearchFieldStates();
  const handleSubmit = (data: SearchFormValues) => {
    console.log('search');

    onSearch(data);
    onClose();
  };
  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Lọc chứng từ cần điều chỉnh'
      maxWidth='lg'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        onSubmit={handleSubmit}
        className='w-full md:min-w-[500px] lg:min-w-[600px]'
        headerFields={<BasicInfoTab formMode='add' searchFieldStates={searchFieldStates} />}
        bottomBar={<BottomActionBarV2 mode='add' onClose={onClose} />}
      />
    </DialogV2>
  );
}

export default SearchDialog;
